<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mPX3y0/tc-custom/9781429972475.jpg?1731883558596" alt="This image is the cover for the book Burn Me Deadly, The Eddie LaCrosse Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burn Me Deadly, The Eddie LaCrosse Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Alex Bledsoe's first novel, <i>The Sword-Edged Blonde,</i> drew rave reviews for its ingenious blend of fantasy and hard-boiled detective fiction. Now Bledsoe returns with an all-new tale of mean streets and medieval intrigue.</b><br/><br/> Above Angelina's Tavern in down-and-dirty Neceda you'll find the office of Eddie LaCrosse, a freelance sword jockey who, for twenty-five gold pieces a day, will take on any task short of murder for hire. Eddie's on his way back from a routine investigation when his horse almost runs down a half-naked blonde in serious trouble. Against his better judgment, he promises to protect the frightened young woman, only to find himself waylaid by unknown assailants and left for dead beside her mutilated body.<br/><br/> Eddie isn't the kind of guy to just let something like this pass. But who killed Laura Lesperitt? Eddie's quest for payback leads him to a tangled mystery involving a notorious crime lord, a backwoods dragon cult, royal scandals, and a duplicitous <i>femme fatale</i> who has trouble keeping her clothes on. As bodies pile up, attracting the unwelcome attention of the king's guards, Eddie must use all his wits if he hopes to survive . . . </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Bledsoe
      </h2>
      
      <p class="authorDescription body article"><P>Alex Bledsoe grew up in west Tennessee. He now lives in Wisconsin.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d36050e